import { defineStore } from 'pinia'

export const useClientStore = defineStore('client', {
  state: () => (    
{
        "clientId": "",
        "addressId": "",
        "name": "",
        "companyNumber": "",
        "clientType": "",
        "clientOnboardingType": "",
        "phoneNumber": "",
        "address": {
            "addressId": "",
            "addressLine1": "",
            "addressLine2": "",
            "addressLine3": "",
            "addressLine4": "",
            "country": "",
            "postCode": ""
        },
        "contacts": [],
    }),
    persist: true,
  actions: {
    setClient(client) {
      Object.assign(this, client)
    }
  },
})